import styled, { css } from 'styled-components';

import { DividerProps } from '.';

export const Wrapper = styled.span<DividerProps>`
  width: 1px;
  height: 14px;
  align-self: center;
  background-color: ${({ theme }) => theme.colors.gray400};
  margin: ${({ marginXAxis }) => (marginXAxis ? `0 ${marginXAxis}` : 0)}px;

  ${({ marginLeft }) =>
    marginLeft &&
    css`
      margin-left: ${marginLeft}px;
    `}

  ${({ marginRight }) =>
    marginRight &&
    css`
      margin-right: ${marginRight}px;
    `}
`;
